import { noop } from 'lodash';
import { useApi } from 'api/api-context';
import { RevisionSingleActionProps } from 'components/tables/data/revision/types';
import { Menu, Tooltip } from '@mantine/core';
import { IconRubberStamp } from '@tabler/icons-react';
import { useConfirmStep } from 'components/tables/data/revision/actions/confirm/ConfirmStepProvider';
import useConfirmAction from 'components/tables/data/revision/actions/hooks/use-confirm-action';
import Button from 'components/Button';
import ActionIcon from 'components/ActionIcon';
import panic from 'errors/panic';

/**
 * Action performed by the user who has the permission to confirm the revision
 */
export default function ConfirmAction({ revision, onStatusChange = noop, kind }: RevisionSingleActionProps) {
  const { getAction } = useApi();
  const { gatherConfirmation } = useConfirmStep();
  const { confirmRevision } = useConfirmAction();

  /** Opens the confirmation modal. */
  const onClick = async () => {
    if (revision) {
      const getRevision = getAction('RevisionGet');

      try {
        const revisionDetail = await getRevision({ parameters: { revisionId: String(revision.revisionId) } });

        gatherConfirmation({
          title: revision.kind === 'revision' ? 'Prebratie revíznej správy' : 'Prebratie formulára',
          revision: revisionDetail,
          onConfirm: (confirmations) => confirmRevision({ revision, confirmations, onStatusChange }),
        });
      } catch (error: any) {
        panic(error);
      }
    }
  };

  if (kind === 'action-icon') {
    return (
      <Tooltip label="Prebrať" events={{ hover: true, focus: true, touch: true }}>
        <ActionIcon variant="primary" size="md" onClick={onClick}>
          <IconRubberStamp />
        </ActionIcon>
      </Tooltip>
    );
  }

  if (kind === 'button') {
    return (
      <Button size="md" onClick={onClick} leftIcon={<IconRubberStamp />} variant="primary" w={188}>
        Prebrať
      </Button>
    );
  }

  return (
    <Menu.Item color="gray.8" onClick={onClick} icon={<IconRubberStamp />}>
      Prebrať
    </Menu.Item>
  );
}
